import { api } from '../core';

export type DocumentBulkCreateDocument = {
  documentId: string;
  documentName: string;
  flagIncorrectCase: boolean;
};

export type DocumentBulkCreateResponse = {
  documents: DocumentBulkCreateDocument[];
};

type DocumentBulkCreateProps = {
  caseId: string;
  documents: {
    documentName: string;
    documentSizeMb: number;
  }[];
};

const documentBulkCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentBulkCreate: builder.query<DocumentBulkCreateResponse, DocumentBulkCreateProps>({
      query: ({ caseId, documents }: DocumentBulkCreateProps) => ({
        url: `document/bulk-create`,
        method: 'POST',
        body: {
          caseId,
          documents,
        },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentBulkCreate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostDocumentBulkCreateQuery } = documentBulkCreateApi;
